import PropTypes from "prop-types";
import * as React from 'react';
import "./Tertiary.css"; // Import the CSS file
import { useTheme } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function Tertiary(props) {
  const [tertiaries, setTertiaries] = React.useState([])

  React.useEffect(() => {
    if (props.categoryMap?.primaries?.[props.primary]?.secondaries?.[props.secondary]?.tertiaries) {
      setTertiaries(Object.keys(props.categoryMap.primaries[props.primary].secondaries[props.secondary].tertiaries));
    }
  }, [props.primary, props.secondary, props.categoryMap]);

  return (
    <div>
      <FormControl sx={{ m: 1, width: '90%' }}>
      <InputLabel id="tertiary-select-label">{props.secondary}</InputLabel>
      <Select
          labelId="tertiary-select-label"
          id="tertiary-select"
          value={props.tertiary}
          onChange={props.handleChange}
          data-testid="tertiary-select"
          label={props.secondary}
        >
          {tertiaries.map((tertiary, index) => (
            <MenuItem
              key={tertiary}
              value={tertiary}
              data-testid={`tertiary-option-${tertiary}`}
            >
              {tertiary}
            </MenuItem>
          ))}
        </Select>
        {/* <InputLabel id="demo-multiple-chip-label">{props.secondary}</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={tertiaryCategory}
          onChange={handleTertiaryChange}
          input={<OutlinedInput id="select-multiple-chip" label={props.secondary} />}
          data-testid="tertiary-select"
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {tertiaries.map((tertiary, index) => (
            <MenuItem
              key={tertiary[1]}
              value={tertiary[1]}
              style={getStyles(tertiary, tertiaryCategory, theme)}
            >
              {tertiary[1]}
            </MenuItem>
          ))}
        </Select> */}
      </FormControl>
    </div>
  );
}

Tertiary.propTypes = {
  handleChange: PropTypes.func,
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string.isRequired,
  tertiary: PropTypes.string.isRequired,
  categoryMap: PropTypes.object.isRequired,
  addData: PropTypes.func
};